module.exports = __webpack_public_path__ + "media/icons/white-diamond-a65ec6a8.png";